module.exports = __webpack_public_path__ + "static/media/create-files.f2807f11.svg";